import { SubText } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { useProcurifyIntl } from '@webapp/hooks'
import {
  type OrderItemFrequencyUnit,
  ORDER_ITEM_FREQUENCY_UNITS,
} from '@webapp/models/enums'
import { type CurrencyName } from '@webapp/models/enums/CurrencyName'
import messages from './messages'
import { FrequencyWrapperStyled, ItemPriceStyled } from './styles'

export interface IItemPriceProps {
  bold?: boolean
  currency?: CurrencyName
  price: number | string
  frequency?: OrderItemFrequencyUnit
}

export const ItemPrice = ({
  bold = true,
  frequency,
  price,
  currency,
}: IItemPriceProps) => {
  const intl = useProcurifyIntl()
  return (
    <ItemPriceStyled>
      <Price
        price={price}
        currency={currency}
        fontWeight={bold ? 'fontWeightBold' : 'fontWeightRegular'}
      />
      {frequency === ORDER_ITEM_FREQUENCY_UNITS.YEARLY ? (
        <FrequencyWrapperStyled>
          <SubText>({intl.formatMessage(messages.yearlyFrequency)})</SubText>
        </FrequencyWrapperStyled>
      ) : frequency === ORDER_ITEM_FREQUENCY_UNITS.MONTHLY ? (
        <FrequencyWrapperStyled>
          <SubText>({intl.formatMessage(messages.monthlyFrequency)})</SubText>
        </FrequencyWrapperStyled>
      ) : null}
    </ItemPriceStyled>
  )
}

ItemPrice.displayName = 'ItemPrice'
